export function isVariantAvailableForSale(variantKey, selectedOptions, variants, optionKey, value) {
  const colourOption = selectedOptions.find((option) => {
    return option.name === 'Color' || option.name === 'Colour';
  })

  const selectedOption = colourOption ?? selectedOptions[0] ?? null;

  const filteredVariants = variants.filter((variant) => {
    if (variantKey === `selected${selectedOption?.name}`) {
      return true;
    }

    const hasMatchingColor = selectedOption
        ? variant.selectedOptions.some(
            (option) =>
                option.name === selectedOption.name &&
                option.value === selectedOption.value
        )
        : true;

    const hasMatchingOption = (option) => {
      return option.name === optionKey && option.value === value;
    }

    return (
        hasMatchingColor && variant.selectedOptions.some((selectedOption) => {
          return hasMatchingOption(selectedOption);
        })
    );
  });

  const [isAvailable] = filteredVariants;

  return isAvailable?.availableForSale ?? false;
}
